export enum ActionType {
    COACHING_DETAIL__TCTD__RELOAD = 'COACHING_DETAIL__TCTD__RELOAD',
    COACHING_DETAIL__TCTD__RELOAD_RESULT = 'COACHING_DETAIL__TCTD__RELOAD_RESULT',
    COACHING_DETAIL__TCTD__FILTER_QUOTES = 'COACHING_DETAIL__TCTD__FILTER_QUOTES',
    COACHING_DETAIL__TCTD__SELECT_QUOTES = 'COACHING_DETAIL__TCTD__SELECT_QUOTES',
    COACHING_DETAIL__TCTD__EDIT_NOTES_FOCUS = 'COACHING_DETAIL__TCTD__EDIT_NOTES_FOCUS',
    COACHING_DETAIL__TCTD__ADD_COMMITMENT_NOTES = 'COACHING_DETAIL__TCTD__ADD_COMMITMENT_NOTES',
    COACHING_DETAIL__TCTD__ADD_COMMITMENT_NOTES_RESULT = 'COACHING_DETAIL__TCTD__ADD_COMMITMENT_NOTES_RESULT',
    COACHING_DETAIL__TCTD__RESET_NAV = 'COACHING_DETAIL__TCTD__RESET_NAV',
}
